<script lang="ts">
  import { fade } from 'svelte/transition';
  import { onDestroy, onMount, tick } from 'svelte';
  import { handleFetchRetry } from '../handleFetchRetry';
  import RejectionReasonModal from '../_shared/RejectionReasonModal.svelte';
  import { debugLog } from '../../lib/debug-log';
  import {
    observeAndAttachValidation,
    personalFields,
    purchaseFields,
    adminComparisonFields
  } from '../fieldValidation';
  import { getAuthHeaders } from '../../lib/authHeaders';
  import { cleanFindingsText, ALL_CRITERIA_FIELDS } from '../../lib/agentTransformations';

  export let row;
  export let mountAdminView = () => null;

  let URL = `${process.env.SVELTE_APP_REMOTE_URL}/api`;
 // Log row whenever it changes
  $: if (row) {
      debugLog('Row updated:', row);
    }  
  $: {
    if (row) {
      import('App/Purchasereceipts/updateById').then((m) => {
        let module = m.default;

        new module({
          target: document.getElementById('purchaseReceipts'),
          layout: 'auto',
          props: {
            dateFormat: 'DD.MM.YYYY - HH:mm',
            layout: 'auto',
            id: row.purchasereceipts.id,
            schema: {
              'field-properties': {
                'hidden-fields': ['id'],
                'field-order': [
                  'purchaseDate',
                  'datesIdentified',
                  'purchaseDateOverride',
                  'totalInvoiceCost',
                  'invoiceDate',
                  'firstRegistration',
                  'mileage',
                  'storage',
                  'storageIdentified',
                  'storageOverride',
                  'switch',
                  'switchIdentified',
                  'switchOverride',
                  'dealerships',
                  'dealershipIdentified',
                  'dealerOverride',
                  'partsId',
                  'partsCount',
                  'partsIdentified',
                  'partsOverrride',
                  'vehicleVersion',
                  "licensePlate",
                  'invitationLicensePlate',
                  'vehicleVin',
                  'invitationVehicleIdentificationNumber',
                  'vehicleVinIdentified',
                  'raw',
                  'rekognitionResponseStep0',
                  'rekognitionResponseStep1',
                  'raw0',
                ],
                // "json-fields": [
                //   {
                //     field: "address",
                //     template: "${street}, ${zip} ${city}",
                //   },
                // ],
                'relational-fields': [
                  {
                    name: 'dealerships',
                    editable: true,
                    columns: ['vfnr', 'name', 'plz', 'ort', 'strasse'],
                  },
                ],
              },
              actions: {
                edit: {
                  removable: false,
                },
              },
            },
          },
        });
        setupFieldValidation();
      });

      import('App/Personalinformation/updateById').then((m) => {
        let module = m.default;

        new module({
          target: document.getElementById('personalInformation'),
          layout: 'auto',
          props: {
            layout: 'auto',
            id: row.personalinformation.id,
            copy: ['name', 'address', 'email'],
            schema: {
              'field-properties': {
                'hidden-fields': [
                  'id',
                  'addressVerified',
                  'addressGeolocation',
                  'phoneVerified',
                  'phone',
                ],
                'field-order': [
                  'name',
                  'invitationName',
                  'address',
                  'invitationAddress',
                  'email',
                  'iban',
                  'ibanVerified',
                ],
                'json-fields': [
                  {
                    field: 'address',
                    template: '${street}, ${zip} ${city}',
                  },
                  // {
                  //   field: 'invitationAddress',
                  //   template: '${street}, ${zip} ${city}',
                  // }
                ],
              },
              actions: {
                edit: {
                  removable: false,
                },
              },
            },
          },
        });
        setupFieldValidation();
      });

      import('App/Purchasepaybacks/updateById').then((m) => {
        let module = m.default;

        new module({
          target: document.getElementById('purchasePaybacks'),
          layout: 'auto',
          props: {
            layout: 'auto',
            id: row.id,
            schema: {
              'field-properties': {
                'hidden-fields': [
                  'paidDate',
                  'paidByMbdDate',
                  'personalinformationIdIdentified',
                  'personalinformationId',
                  'personalinformation',
                  'purchasereceipts',
                  'purchasereceiptsId',
                  'personalinformationOverride',
                  'questions',
                  ...ALL_CRITERIA_FIELDS,
                ],
                'boolean-fields': ['completed'],
                'readonly-fields': [
                  'id',
                  'invoiceNumber',
                  'date',
                  'agentDecision',
                  'agentFindings',
                  ...ALL_CRITERIA_FIELDS,
                ],
                'textarea-fields': ['agentFindings'],
                'field-order': [
                  'id',
                  'invoiceNumber',
                  'date',
                  'completed',
                  'status',
                  'cashbackType',
                  'agentDecision',
                  'agentFindings',
                ],
                'dropdown-fields': [
                  {
                    name: 'cashbackType',
                    default: {
                      label: 'cashback-basic',
                      value: 'cashback-basic',
                    },
                    options: [
                      {
                        label: 'cashback-basic',
                        value: 'cashback-basic',
                      },
                      {
                        label: 'cashback-full',
                        value: 'cashback-full',
                      },
                    ],
                  },
                  {
                    name: 'status',
                    default: {
                      label: 'VERIFICATION',
                      value: 'VERIFICATION',
                    },
                    options: [
                      {
                        label: 'INCOMPLETE',
                        value: 'INCOMPLETE',
                      },
                      {
                        label: 'REJECTED',
                        value: 'REJECTED',
                      },
                      {
                        label: 'VERIFICATION',
                        value: 'VERIFICATION',
                      },
                      {
                        label: 'PRE-APPROVED',
                        value: 'PRE-APPROVED',
                      },
                      {
                        label: 'APPROVED',
                        value: 'APPROVED',
                      },
                      {
                        label: 'PRE-PAYMENT',
                        value: 'PRE-PAYMENT',
                      },
                      {
                        label: 'PAID',
                        value: 'PAID',
                      },
                      {
                        label: 'PARKING1',
                        value: 'PARKING1',
                      },
                      {
                        label: 'PARKING2',
                        value: 'PARKING2',
                      },
                      {
                        label: 'PARKING3',
                        value: 'PARKING3',
                      },
                      {
                        label: 'PARKING4',
                        value: 'PARKING4',
                      },
                      {
                        label: 'PARKING5',
                        value: 'PARKING5',
                      },
                      {
                        label: 'transferred to mbdcb140',
                        value: 'transferred to mbdcb140',
                      },
                    ],
                  },
                ],
              },
              actions: {
                edit: {
                  removable: false,
                },
              },
            },
          },
        });
      });
    }
  }

  let documentEl;
  let pdfUrl = null;
  let rejectionReason;
  let fullScreen = false;
  let pdfUrlLoading = false;
  let lastFetchedRowId: number | null = null;

  let areasOpen = {
    personalInformationArea: true,
    purchaseReceiptsArea: true,
    purchasePaybacksArea: true,
  };

  let aiVerifying = false;
  let aiVerifyError = '';

  async function triggerAiVerification() {
    if (!row?.id || aiVerifying) return;
    aiVerifying = true;
    aiVerifyError = '';
    try {
      const res = await fetch(`${URL}/purchasepaybacks/${row.id}/verify`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => null);
        throw new Error(errData?.error?.message || errData?.message || `Verification failed (status ${res.status})`);
      }
      const data = await res.json();
      if (data?.verdict) {
        row.agentDecision = data.verdict.decision ?? null;
        row.agentFindings = data.verdict.findings ?? '';
        row = { ...row };
      }
      if (mountAdminView) mountAdminView();
    } catch (err: any) {
      aiVerifyError = err?.message || 'Failed to run AI verification';
    } finally {
      aiVerifying = false;
    }
  }

  let confirmationModal = {
    open: false,
    thereAreChanges: false,
  };
  let rejectionReasonModalOpen = false;

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      if (confirmationModal.open) {
        confirmationModal.open = false;
      } else if (rejectionReasonModalOpen) {
        rejectionReasonModalOpen = false;
      } else if (row) {
        if (confirmationModal.thereAreChanges) {
          confirmationModal.open = true;
        } else {
          row = null;
          pdfUrl = null;
          closeFullScreen();
        }
      }
    }
  }

  // Auto-reset the guard whenever row is cleared (covers ALL close paths:
  // closeModal(), the X-button inline handler, future paths, etc.)
  // This ensures re-opening any row always triggers a fresh fetch.
  $: if (!row) lastFetchedRowId = null;

  // Only re-fetch when the row actually changes (guard by row.id).
  // Writing pdfUrlLoading inside a $: block caused Svelte to re-run the
  // block on every assignment → infinite fetch loop on slow networks.
  $: if (row && row.id !== lastFetchedRowId) {
    loadPdfUrl(row);
  }

  async function loadPdfUrl(currentRow: any) {
    lastFetchedRowId = currentRow.id; // set guard immediately to block re-entry
    pdfUrl = null;
    try {
      pdfUrlLoading = true;
      debugLog({ pdf: currentRow.purchasereceipts });
      const response = JSON.parse(currentRow.purchasereceipts.raw);
      debugLog({ response });
      // filename is the last two components of the url
      let merged = response.merged.split('/');
      let fileName =
        merged[merged.length - 2] + '/' + merged[merged.length - 1];
      debugLog({ filename: fileName });

      const res = await fetch(`${URL}/get-presigned-url`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ fileName }),
      });
      const data = await res.json();
      pdfUrl = data.url;
      debugLog({ pdfUrl });
    } catch (e) {
      debugLog(e);
    } finally {
      pdfUrlLoading = false;
    }
  }

  async function waitForElement(selector, timeoutMs = 5000, intervalMs = 100) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const el = document.querySelector(selector);
      if (el) return el;
      await new Promise((r) => setTimeout(r, intervalMs));
    }
    return null;
  }

  const SAVE_SELECTORS = {
    personalInformation:
      '#personalInformation > div > div > form > div.p-4.sticky.bottom-0.bg-white.w-full.flex.space-x-4.justify-center > button:nth-child(2)',
    purchaseReceipts:
      '#purchaseReceipts >div > div > form > div.p-4.sticky.bottom-0.bg-white.w-full.flex.space-x-4.justify-center > button:nth-child(2)',
    purchasePaybacks:
      '#purchasePaybacks > div > div > form > div.p-4.sticky.bottom-0.bg-white.w-full.flex.space-x-4.justify-center > button:nth-child(2)',
  };

  let isSaving = false;
  let instancePendingRequests = 0;
  let instanceExpectedPatches = new Set<string>();

  if (!(window as any).__mb_fetch_interceptor) {
    const origFetch = window.fetch;
    (window as any).__mb_force_approve_map = new Map();
    (window as any).__mb_active_instances = new Set();
    
    (window as any).__mb_fetch_interceptor = async function(input, init) {
      const url = typeof input === 'string' ? input : ((input as any)?.url || (input as any)?.href);
      const method = init?.method?.toUpperCase();

      (window as any).__mb_active_instances.forEach((instance: any) => instance.onRequestStart(url, method));

      if (method === 'PATCH' && url && url.includes('/api/purchasepaybacks/')) {
        const match = url.match(/\/api\/purchasepaybacks\/(\d+)/);
        if (match) {
          const rowId = parseInt(match[1], 10);
          const approvedAt = (window as any).__mb_force_approve_map.get(rowId);
          if (approvedAt && Date.now() - approvedAt < 60000) { // Protect for 60 seconds
            try {
              const body = JSON.parse(init.body as string);
              if (body.status !== 'APPROVED') {
                body.status = 'APPROVED';
                init = { ...init, body: JSON.stringify(body) };
              }
            } catch (e) {}
          }
        }
      }

      try {
        return await origFetch.apply(this, [input, init] as any);
      } finally {
        (window as any).__mb_active_instances.forEach((instance: any) => instance.onRequestEnd(url));
      }
    };
    window.fetch = (window as any).__mb_fetch_interceptor;
  }

  const fetchInstance = {
    onRequestStart: (url: string, method: string) => {
      instancePendingRequests++;
      if (method === 'PATCH') {
        instanceExpectedPatches.forEach(expectedUrl => {
          if (url && url.includes(expectedUrl)) {
            instanceExpectedPatches.delete(expectedUrl);
          }
        });
      }
    },
    onRequestEnd: (url: string) => {
      instancePendingRequests--;
    }
  };

  const waitForRequestsToFinish = async (timeoutMs = 30000) => {
    const start = Date.now();
    let idleStart = null;
    
    while (true) {
      if (Date.now() - start > timeoutMs) {
        break; 
      }

      if (instanceExpectedPatches.size === 0 && instancePendingRequests === 0) {
        break;
      }

      if (instancePendingRequests === 0) {
        if (!idleStart) {
          idleStart = Date.now();
        } else if (Date.now() - idleStart >= 2500) {
          break;
        }
      } else {
        idleStart = null;
      }
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
  };

  const saveInformation = async () => {
    instanceExpectedPatches.clear();
    if (row?.personalinformation?.id) instanceExpectedPatches.add(`/api/personalinformations/${row.personalinformation.id}`);
    if (row?.purchasereceipts?.id) instanceExpectedPatches.add(`/api/purchasereceipts/${row.purchasereceipts.id}`);
    if (row?.id) instanceExpectedPatches.add(`/api/purchasepaybacks/${row.id}`);

    try {
      for (const [name, selector] of Object.entries(SAVE_SELECTORS)) {
        const btn = await waitForElement(selector);
        if (!btn) {
          continue; // don't silently pretend it worked; at least log it
        }
        btn.click();
      }

      // give click handlers a moment to actually invoke fetch() before we
      // start trusting instancePendingRequests === 0 as "nothing left to wait for"
      await tick();
      await new Promise((r) => setTimeout(r, 100));

      await waitForRequestsToFinish();
    } finally {
    }
  };

  const approvePurchasePayback = async () => {
    const patchEndpoint = `${URL}/purchasepaybacks/${row.id}`;
    
    // Protect this row from zombie reversions for the next 60 seconds
    (window as any).__mb_force_approve_map.set(row.id, Date.now());

    try {
      await saveInformation();
    } catch (e) {
      debugLog({ message: 'Saving took too long or failed before approval', error: e });
      return;
    }

    await handleFetchRetry(() =>
      fetch(`${URL}/purchasepaybacks/${row.id}`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          status: 'APPROVED',
          approvedDate: row.approvedDate && row.approvedDate !== 'Invalid Date' ? undefined : new Date().toISOString(),
        }),
      }),
    );

    closeModal();
    mountAdminView();
  };

  const updateRow = async (rowId, fields) => {
    await fetch(`${URL}/purchasepaybacks/${rowId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(fields),
    });
    closeModal();
    mountAdminView();
  };

  const confirmRejection = async () => {
    const event = new CustomEvent('updateRow', {
      detail: {
        rowId: row.id,
        fields: {
          status: 'REJECTED',
          rejectionReason,
        },
      },
    });

    window.dispatchEvent(event);
    rejectionReasonModalOpen = false;
  };

  const openFullScreen = () => {
    fullScreen = true;
    if (documentEl.requestFullscreen) {
      documentEl.requestFullscreen();
    } else if (documentEl.mozRequestFullScreen) {
      documentEl.mozRequestFullScreen();
    } else if (documentEl.webkitRequestFullscreen) {
      documentEl.webkitRequestFullscreen();
    } else if (documentEl.msRequestFullscreen) {
      documentEl.msRequestFullscreen();
    }
  };

const closeFullScreen = () => {
  fullScreen = false;
  // Check if any element is currently in fullscreen
  const el =
    document.fullscreenElement ||
    (document as any).webkitFullscreenElement ||
    (document as any).mozFullScreenElement ||
    (document as any).msFullscreenElement;

  if (!el) return; // nothing to exit, avoid throwing

  try {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  } catch (e) {
    // Silently ignore errors when document is not active
    debugLog({ error: 'exitFullscreen failed', e });
  }
};

  const closeModal = () => {
    closeFullScreen();
    teardownFieldValidation();
    confirmationModal.thereAreChanges = false;
    confirmationModal.open = false;
    pdfUrl = null;
    lastFetchedRowId = null; // reset guard so re-opening any row triggers a fresh fetch
    row = null;
  };

  onMount(() => {
    (window as any).__mb_active_instances.add(fetchInstance);
    window.addEventListener('updateRow', (e) => {
      updateRow(e.detail.rowId, e.detail.fields);
    });

    window.addEventListener('approve', (e) => {
      debugLog(e.detail);
      row = e.detail;
    });
  });

  onDestroy(() => {
    window.removeEventListener('updateRow', (e) => {
      debugLog(e.detail);
    });

    window.removeEventListener('approve', (e) => {
      debugLog(e.detail);
    });
    teardownFieldValidation();
    (window as any).__mb_active_instances.delete(fetchInstance);
    // Note: We intentionally DO NOT restore window.fetch here! 
    // The global interceptor must remain active to catch zombie requests from dying widgets.
  });

  $: documentEl = document?.documentElement;

  let personalValidationController: any = null;
  let purchaseValidationController: any = null;

  function setupFieldValidation() {
    teardownFieldValidation();

    const personalMount = document.getElementById('personalInformation');
    if (personalMount) {
      personalValidationController = observeAndAttachValidation(personalMount, {
        fields: personalFields,
        debounceMs: 50,
      });
    }

    const purchaseMount = document.getElementById('purchaseReceipts');
    if (purchaseMount) {
      purchaseValidationController = observeAndAttachValidation(purchaseMount, {
        fields: purchaseFields,
        debounceMs: 50,
      });
    }
  }

  function teardownFieldValidation() {
    try {
      personalValidationController?.stop?.();
    } catch {}
    try {
      purchaseValidationController?.stop?.();
    } catch {}
    personalValidationController = null;
    purchaseValidationController = null;
  }
</script>

<svelte:window on:keydown={handleKeyDown} />

<RejectionReasonModal
  bind:inputValue={rejectionReason}
  submitFunction={confirmRejection}
  bind:open={rejectionReasonModalOpen}
/>

{#if row}
  <div
    class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!-- Are you sure you want to close? (Modal) -->
    {#if confirmationModal.open}
      <div
        transition:fade={{ delay: 0, duration: 200 }}
        class="fixed inset-0 z-[9999] overflow-y-auto"
        aria-labelledby="modal-title"
        aria-modal="true"
        role="dialog"
      >
        <div
          class="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
          <span
            class="hidden sm:inline-block sm:h-screen sm:align-middle"
            aria-hidden="true">​</span
          >
          <div
            class="relative inline-block transform overflow-hidden rounded-[7px] bg-white px-4 pt-5 pb-4 text-left align-middle shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle"
          >
            <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
              <button
                type="button"
                class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span class="sr-only"> Close </span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                  ><path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="sm:flex sm:items-start">
              <div
                class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
              >
                <svg
                  class="h-6 w-6 text-red-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                  ><path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  class="text-lg font-medium leading-6 text-gray-900"
                  id="modal-title"
                >
                  Alert
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    Are you sure, you want to close? You may lose unsaved
                    changes.
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                on:click={closeModal}
                type="button"
                class="inline-flex w-full justify-center rounded-[7px] border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Yes,Close
              </button>
              <button
                on:click={() => (confirmationModal.open = false)}
                type="button"
                class="mt-3 inline-flex w-full justify-center rounded-[7px] border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    {/if}
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      aria-hidden="true"
    />
    <div
      class={`flex min-h-screen w-full flex-1 items-center justify-center ${
        fullScreen ? 'p-0' : 'px-4 pt-4'
      }`}
    >
      <div
        class={`w-full ${
          fullScreen
            ? 'm-0 h-screen p-2 md:w-full lg:w-full'
            : 'px-4 pt-5 pb-4 md:w-11/12 lg:w-9/12'
        } 
        relative inline-block transform overflow-hidden rounded-lg bg-white 
        text-left align-bottom shadow-xl transition-all duration-200`}
      >
        <div class="flex justify-end">
          <!-- Full screen button -->
          <div class="flex items-center gap-2">
            <button
              on:click={() => {
                if (!fullScreen) openFullScreen();
                else closeFullScreen();
              }}
              class="button ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900"
            >
              {#if !fullScreen}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M16 4l4 0l0 4" />
                  <path d="M14 10l6 -6" />
                  <path d="M8 20l-4 0l0 -4" />
                  <path d="M4 20l6 -6" />
                  <path d="M16 20l4 0l0 -4" />
                  <path d="M14 14l6 6" />
                  <path d="M8 4l-4 0l0 4" />
                  <path d="M4 4l6 6" />
                </svg>
              {:else}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 9l4 0l0 -4" />
                  <path d="M3 3l6 6" />
                  <path d="M5 15l4 0l0 4" />
                  <path d="M3 21l6 -6" />
                  <path d="M19 9l-4 0l0 -4" />
                  <path d="M15 9l6 -6" />
                  <path d="M19 15l-4 0l0 4" />
                  <path d="M15 15l6 6" />
                </svg>
              {/if}
              <style>
                button:hover > svg {
                  stroke: #111827;
                }
              </style>
            </button>
            <button
              type="button"
              class="button ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900"
              data-modal-toggle="defaultModal"
              on:click={() => {
                if (confirmationModal.thereAreChanges)
                  confirmationModal.open = true;
                else {
                  row = null;
                  pdfUrl = null;
                  closeFullScreen();
                }
              }}
            >
              <svg
                aria-hidden="true"
                class="h-5 w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                /></svg
              >
              <span class="sr-only">Close modal</span>
            </button>
          </div>
        </div>
        <div class="flex max-h-[calc(100vh-100px)] flex-row">
          <div class="w-1/2">
            <div>
              <!-- <div id="pdf" /> -->
              <!-- <Pdf
                  url={row.purchasereceipts.raw}
                  data={row.purchasereceipts.raw}
                /> -->
              {#if !pdfUrlLoading && pdfUrl}
                <div class="h-screen w-full pr-4">
                  <!-- Adobe Embed API -->
                  <!-- <div id="embeded-pdf-div"></div>
                  <script lang="ts">
                    (() => {
                      let adobeDCView = new AdobeDC.View({
                        clientId: clientId, 
                        divId: "embeded-pdf-div"
                      });
                      adobeDCView.previewFile({
                        content:{ location: { url: "/mbd_terms.pdf" } },
                        metaData:{ fileName: "pdf" }
                      }, 
                      { 
                        embedMode: "FULL_WINDOW", 
                        defaultViewMode: "FIT_PAGE", 
                        showAnnotationTools: true, 
                        showDownloadPDF: true
                      });
                    })();
                  </script> -->
                  <embed
                    class="rounded-lg"
                    src={`${pdfUrl}`}
                    width="100%"
                    height="100%"
                    title="PDF"
                  />
                </div>
              {:else if !pdfUrlLoading && !pdfUrl}
                <div class="flex items-center justify-center">
                  <div class="flex flex-col items-center">
                    <svg
                      class="h-10 w-10 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 14a6 6 0 110-12 6 6 0 010 12z"
                        clip-rule="evenodd"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10 4a1 1 0 011 1v4a1 1 0 11-2 0V5a1 1 0 011-1z"
                        clip-rule="evenodd"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10 11a1 1 0 100 2 1 1 0 000-2z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="text-sm text-gray-400">No PDF found</span>
                  </div>
                </div>
                <!-- loading -->
              {:else if pdfUrlLoading}
                <div class="flex items-center justify-center">
                  <div class="flex flex-col items-center">
                    <svg
                      class="mr-3 -ml-1 h-5 w-5 animate-spin text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      />
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      />
                    </svg>
                    <span class="text-sm text-gray-400">Loading PDF</span>
                  </div>
                </div>
              {/if}

              <!-- <PdfViewer url={row.purchasereceipts.raw} /> -->
            </div>
          </div>

          <div
            on:keyup={() => (confirmationModal.thereAreChanges = true)}
            class="relative flex w-1/2 flex-col gap-4 overflow-y-auto"
          >
            <!-- AI Agent Verification Card -->
            <div class="rounded-xl border {row?.agentDecision === 'APPROVABLE' ? 'border-emerald-300 bg-emerald-50/50' : row?.agentDecision === 'UNSURE' ? 'border-amber-300 bg-amber-50/50' : row?.agentDecision === 'NOT_APPROVABLE' ? 'border-rose-300 bg-rose-50/50' : 'border-slate-200 bg-slate-50/70'} p-4 shadow-sm transition-all duration-200">
              <div class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-2.5">
                  <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-white shadow-xs border border-slate-200 text-indigo-600 shrink-0">
                    <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                    </svg>
                  </div>
                  <div>
                    <h3 class="text-sm font-bold text-slate-800 flex items-center gap-1.5">
                      <span>AI Agent Assessment</span>
                    </h3>
                    <p class="text-[11px] text-slate-500">Automated invoice, amounts &amp; rules check</p>
                  </div>
                </div>

                <div class="flex items-center gap-2">
                  {#if row?.agentDecision === 'APPROVABLE'}
                    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-300">
                      <svg class="w-3.5 h-3.5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      Approvable
                    </span>
                  {:else if row?.agentDecision === 'UNSURE'}
                    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-300">
                      <svg class="w-3.5 h-3.5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      </svg>
                      Unsure
                    </span>
                  {:else if row?.agentDecision === 'NOT_APPROVABLE'}
                    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-rose-100 text-rose-800 border border-rose-300">
                      <svg class="w-3.5 h-3.5 text-rose-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                      Not Approvable
                    </span>
                  {:else}
                    <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-slate-200 text-slate-600">Not Analyzed</span>
                  {/if}

                  <button
                    type="button"
                    disabled={aiVerifying}
                    on:click={triggerAiVerification}
                    class="inline-flex items-center gap-1.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 px-3 py-1.5 text-xs font-semibold text-white shadow-xs transition-colors cursor-pointer"
                  >
                    {#if aiVerifying}
                      <div class="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                      <span>Verifying…</span>
                    {:else}
                      <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                      </svg>
                      <span>{row?.agentFindings ? 'Re-run Agent' : 'Run Agent'}</span>
                    {/if}
                  </button>
                </div>
              </div>

              {#if aiVerifyError}
                <div class="mt-3 rounded-lg border border-red-200 bg-red-50 p-2.5 text-xs text-red-700">
                  {aiVerifyError}
                </div>
              {/if}

              {#if row?.agentFindings}
                <div class="mt-3">
                  <div class="flex items-center justify-between mb-1.5">
                    <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Agent Findings</span>
                    <button
                      type="button"
                      class="text-[11px] text-indigo-600 hover:text-indigo-800 font-medium cursor-pointer"
                      on:click={() => navigator.clipboard.writeText(cleanFindingsText(row?.agentFindings || ''))}
                    >
                      Copy findings
                    </button>
                  </div>
                  <div class="max-h-48 overflow-y-auto rounded-lg border border-slate-700 bg-slate-900 p-3 font-mono text-xs text-slate-100 leading-relaxed whitespace-pre-wrap select-text">
                    {cleanFindingsText(row.agentFindings)}
                  </div>
                </div>
              {/if}
            </div>

            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              on:click={() =>
                (areasOpen.purchasePaybacksArea =
                  !areasOpen.purchasePaybacksArea)}
              class="flex cursor-pointer items-center justify-between rounded-lg border-b-[1px] border-gray-400 p-2 duration-200 hover:bg-gray-100"
            >
              <h1 class="text-bold text-[20px] text-gray-600">
                Purchase Paybacks
              </h1>
              {#if areasOpen.purchasePaybacksArea}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              {:else}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 6l6 6l-6 6" />
                </svg>
              {/if}
            </div>
            {#if !row?.id}
              <span
                class={`${!areasOpen.purchasePaybacksArea ? 'hidden' : 'px-2'}`}
              >
                No purchase payback
              </span>
            {/if}
            <div
              id="purchasePaybacks"
              class={`${!areasOpen.purchasePaybacksArea ? 'hidden' : ''}`}
            />

            <!-- Personal Information Area -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              on:click={() =>
                (areasOpen.personalInformationArea =
                  !areasOpen.personalInformationArea)}
              class="flex cursor-pointer items-center justify-between rounded-lg border-b-[1px] border-gray-400 p-2 duration-200 hover:bg-gray-100"
            >
              <h1 class="text-bold text-[20px] text-gray-600">
                Personal Information
              </h1>
              {#if areasOpen.personalInformationArea}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              {:else}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 6l6 6l-6 6" />
                </svg>
              {/if}
            </div>
            {#if !row?.personalinformation?.id}
              <span
                class={`${!areasOpen.personalInformationArea ? 'hidden' : 'px-2'}`}
              >
                No personal information
              </span>
            {/if}
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              id="personalInformation"
              on:click={(e) => {
                debugLog('CLICK');
                // debugLog('COPIED => ', e.clipboardData.getData());
              }}
              class={`${!areasOpen.personalInformationArea ? 'hidden' : ''}`}
            />

            <!-- Purchase Receipts Area -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              on:click={() =>
                (areasOpen.purchaseReceiptsArea =
                  !areasOpen.purchaseReceiptsArea)}
              class="mb-4 flex cursor-pointer items-center justify-between rounded-lg border-b-[1px] border-gray-400 p-2 duration-200 hover:bg-gray-100"
            >
              <h1 class="text-bold text-[20px] text-gray-600">
                Purchase Receipts
              </h1>
              {#if areasOpen.purchaseReceiptsArea}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              {:else}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#9CA3AF"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 6l6 6l-6 6" />
                </svg>
              {/if}
            </div>
            {#if !row?.purchasereceipts?.id}
              <span
                class={`${!areasOpen.purchaseReceiptsArea ? 'hidden' : 'px-2'}`}
              >
                No purchase receipts
              </span>
            {/if}
            <div
              id="purchaseReceipts"
              class={`${!areasOpen.purchaseReceiptsArea ? 'hidden' : ''}`}
            />
          </div>
        </div>
        <div class="flex justify-end gap-4 p-2">
          <button
            class="w-full rounded border border-gray-600 px-6 py-3 text-center text-sm font-semibold text-gray-600 shadow-sm transition-all hover:text-black hover:shadow-md active:shadow-none sm:ml-3 sm:w-auto"
            on:click={() => {
              if (confirmationModal.thereAreChanges)
                confirmationModal.open = true;
              else {
                row = null;
                pdfUrl = null;
                closeFullScreen();
              }
            }}
            buttontype="default"
            buttontext="Delete"
          >
            Cancel
          </button>
          <button
            class="button"
            on:click={async () => {
              rejectionReasonModalOpen = true;
            }}>Reject</button
          >
          <button
            class="button"
            disabled={isSaving}
            on:click={async () => {
              isSaving = true;
              try {
                // set verified to true to the current selected rowId
                await saveInformation();
                closeModal();
                mountAdminView();
                // force a refresh of the table
              } finally {
                isSaving = false;
              }
            }}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
          <button
            class="button"
            disabled={isSaving}
            on:click={async () => {
              isSaving = true;
              try {
                // set verified and approved to true to the current selected rowId
                await approvePurchasePayback();
                // force a refresh of the table
              } finally {
                isSaving = false;
              }
            }}
          >
            {isSaving ? 'Approving...' : 'Approve'}
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}
